<template>
  <div>
    <b-container fluid class="shadow-sm">
      <b-row align-h="center" class="pt-3">
        <b-col lg="8" sm="8" class="d-flex flex-column justify-content-center">
          <TitleBadge
            :type="submitalCategory"
          >
            <template #id>
              <span v-if="submital.id">
                <button
                  type="button"
                  class="lock-btn"
                  :class="submitalLocked ? 'lock-btn--unlock' : 'lock-btn--lock'"
                  @click="showLockModal = true"
                >
                  <font-awesome-icon :icon="['fas', submitalLocked ? 'lock-open-alt' : 'lock-alt']" />
                  {{ submitalLocked ? 'Desbloquear' : 'Bloquear' }}
                </button>
                <span>
                  <font-awesome-icon v-if="submital.locked_at" :icon="['fas', 'lock-alt']" fixed-width class="text-danger" />
                  {{ submital.submital_no }}
                </span>
              </span>
            </template>
            <template #title>
              <span v-if="submital.id">
                <span v-if="badgeTitle">{{ badgeTitle }}</span>
                <span v-else class="text-danger fs-15">Sin nombre</span>
              </span>
              <span v-else class="text-muted">No se encontró el submital consultado</span>
            </template>
          </TitleBadge>
        </b-col>
        <b-col lg="2" sm="3" class="text-right">
          <p class="fs-12 text-muted mb-0">Progreso %</p>
          <div v-if="submital.id" class="d-flex justify-content-end align-items-baseline">
            <span v-if="submital.progress == 100" class="progress-circle mt-2 bg-success">{{ submital.progress }}</span>
            <span v-else-if="submital.progress > 50" class="progress-circle mt-2 bg-warning">{{ submital.progress }}</span>
            <span v-else class="progress-circle mt-2 bg-danger">{{ submital.progress }}</span>
          </div>
          <div v-else class="d-flex justify-content-end align-items-baseline">
            <span class="progress-circle mt-2 bg-danger">{{ 0 }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-2 pb-3">
        <b-col lg="10" sm="9">
          <b-row>
            <b-col md="4" cols="12" class="text-truncate mb-3 mb-sm-0">
              <p class="font-lato text-muted mb-0 fs-15">Cliente</p>
              <b-link v-if="submital.id && submital.client" :to="`/app/prod/clientes/${submital.client.id}`" class="related-link">
                <span class="fs-14">{{ submital.client.name }}</span>
              </b-link>
              <p v-else class="text-muted"> - </p>
            </b-col>
            <b-col md="4" cols="6" class="text-truncate">
              <p class="font-lato text-muted mb-0 fs-15">Proyecto</p>
              <b-link v-if="submital.id && submital.project" :to="`/app/prod/proyectos/${submital.project.id}`" class="related-link">
                <span class="fs-14">{{ submital.project.name }}</span>
              </b-link>
              <p v-else class="text-muted"> - </p>
            </b-col>
            <b-col md="4" cols="6">
              <p class="font-lato text-muted mb-0 fs-15">Asesor</p>
              <p v-if="submital.id && submital.salesperson" class="mb-0 fs-14">
                {{ submital.salesperson.first_name }} {{ submital.salesperson.last_name }}
              </p>
              <p v-else class="text-muted"> - </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row align-h="center" class="custom-tabs custom-tabs-lg mt-3">
        <b-col lg="8" sm="9" cols="11">
          <b-row align-h="center">
            <ul>
              <li>
                <b-link v-if="submital.id" :to="`/app/prod/submitals/${submital.id}`" :active="page === 'submital'" class="dash-nav-link">
                  Submital
                </b-link>
                <p v-else class="dash-nav-link"> Submital</p>
              </li>
              <li>
                <b-link v-if="submital.id" :to="`/app/prod/submitals/${submital.id}/fotos`" :active="page === 'fotos'" class="dash-nav-link">
                  Fotos
                  <div class="counter-badge">{{ submital.photos_count }}</div>
                </b-link>
                <p v-else class="dash-nav-link"> Fotos</p>
              </li>
              <li>
                <b-link v-if="submital.id" :to="`/app/prod/submitals/${submital.id}/documentos`" :active="page === 'documentos'" class="dash-nav-link">
                  Documentos
                  <!-- <div class="counter-badge"></div> -->
                </b-link>
                <p v-else class="dash-nav-link"> Documentos</p>
              </li>
              <li>
                <b-link v-if="submital.id" :to="`/app/prod/submitals/${submital.id}/admin`" :active="page === 'admin'" class="dash-nav-link">
                  Admin
                </b-link>
                <p v-else class="dash-nav-link"> Admin</p>
              </li>
            </ul>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <SubmitalLockModal
      :show="showLockModal"
      @close="showLockModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TitleBadge from '../../shared/TitleBadge'
import SubmitalLockModal from './SubmitalLockModal'

export default {
  name: 'SubmitalHeader',
  components: { TitleBadge, SubmitalLockModal},
  props: {
    submital: {
      type: Object,
      default: () => {}
    },
    page: {
      type: String
    }
  },
  data () {
    return { showLockModal: false }
  },
  computed: {
    ...mapGetters (['configurableType', 'submitalCategory', 'submitalLocked']),
    badgeTitle () {
      if (!this.submital.id) return ''
      return this.submital.title ? this.submital.title : ''
    }
  }
}
</script>

<style scoped>
.lock-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-right: 8px;
  padding: 3px 10px;
  border-radius: 6px;
  border: 1px solid;
  background: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  vertical-align: middle;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.lock-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.lock-btn--lock {
  color: #141313;
  border-color: #ffc107;
  background: #ffc107;
}
.lock-btn--lock:hover {
  background: #b3801a;
  color: #fff;
}

.lock-btn--unlock {
  color: #f9fbfc;
  border-color: #007bff;
  background: #007bff;
}
.lock-btn--unlock:hover {
  background: #0b5bd4;
  color: #fff;
}
</style>